import { useMediaQuery } from "usehooks-ts";

// Tailwind v4's default `sm` breakpoint is 40rem/640px and this project sets no
// `screens` override, so "small screen" here is everything below `sm`. The
// fractional upper bound avoids the half-pixel gap on fractional viewports.
export const SMALL_SCREEN_MAX_WIDTH_PX = 639;
export const SMALL_SCREEN_MEDIA_QUERY = "(max-width: 639.98px)";

/**
 * True below the `sm` breakpoint. Selector menus use this to swap a floating
 * popover for a bottom sheet, which is the only presentation with room for a
 * two-line account row on a phone.
 */
export function useIsSmallScreen(): boolean {
  return useMediaQuery(SMALL_SCREEN_MEDIA_QUERY, { defaultValue: false });
}
